module.exports = __webpack_public_path__ + "img/efecty-icon.13bfaa0a.svg";